import React from 'react'
import { useForm } from '@tanstack/react-form'
import { checkoutSchema, type CheckoutFields, type Position } from './schema'

type Options = {
  defaultPositions: Position[]
  onSubmit: () => Promise<void> | void
  initialValues?: CheckoutFields | null
}

const buildEmptyDefaults = (positions: Position[]): CheckoutFields => ({
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  company: '',
  address: '',
  resolvedAddress: null,
  date: '',
  positions,
})

export const useCheckoutForm = ({
  defaultPositions,
  onSubmit,
  initialValues = null,
}: Options) => {
  const defaultValues = React.useMemo(
    () => initialValues ?? buildEmptyDefaults(defaultPositions),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )
  return useForm({
    defaultValues,
    validators: { onSubmit: checkoutSchema },
    onSubmit,
  })
}

export type CheckoutForm = ReturnType<typeof useCheckoutForm>
